import React from 'react';
import { Box, Button } from '@mui/material';

import activityImg from '../../../assets/seachb.png';

const ProfileEmpty = () => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '1090px',
        background: '#fff',
        borderRadius: '16px',
        p: { xs: '16px', md: '24px' },
        minHeight: '400px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
        boxSizing: 'border-box',
        m: 0,
      }}
    >
      <Box
        sx={{
          background: '#F4F2FF',
          p: '10px',
          borderRadius: '16px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <img src={activityImg} alt="Start Search" style={{ width: '160px', marginBottom: '16px' }} />
        <Button
          sx={{
            px: '12px',
            py: '10px',
            border: '1px solid #fff',
            backgroundColor: '#fff',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 500,
            color: '#3C2E88',
            textTransform: 'none',
          }}
        >
          Start new search
        </Button>
      </Box>
    </Box>
  );
};

export default ProfileEmpty;
